import React from 'react';
import TextBlinkCustom from '../../../../common/text-blink-custom';
import { formatTextFloat, formatPrice } from '../../../../helpers/Text';
import { getDataFollowKeyByDot } from '../../../../helpers/Common';
import { connect } from 'react-redux';
import { REDUCER_NAME } from '../reducer';
import { getColorPrice } from './../../../../helpers/Color';
import PriceInfoCommon from '../../../../common/index-summary/PriceInfo';
import Const from '../../../../common/Const';
import { isTicker } from '../../../../helpers/Common';

const mapStateToProps = state => {
  return {
    indexSumary: state[REDUCER_NAME].indexSumary,
    currentSearch: state[REDUCER_NAME].currentSearch,
    indexSumaryRealtime: state[REDUCER_NAME].indexSumaryRealtime,
  };
};
class PriceInfo extends React.Component {
  getDataByTypeSearch = (priceParam, referencePriceParam) => {
    const { indexSumary } = this.props;
    let price = formatTextFloat(priceParam);
    let referencePrice = formatTextFloat(referencePriceParam);
    if (isTicker(indexSumary)) {
      price = formatPrice(priceParam);
      referencePrice = formatPrice(referencePriceParam);
    }
    return [price, referencePrice];
  };

  getChangeByTypeSearch = () => {
    const { indexSumary } = this.props;
    let change = formatTextFloat(
      getDataFollowKeyByDot(indexSumary, Const.indexData.VALUE_CHANGE),
    );
    if (isTicker(indexSumary)) {
      change = formatTextFloat(
        formatPrice(
          getDataFollowKeyByDot(indexSumary, Const.indexData.VALUE_CHANGE),
        ),
      );
    }
    return change;
  };

  render() {
    const { indexSumary } = this.props;

    const price = getDataFollowKeyByDot(indexSumary, Const.indexData.VALUE);
    const referencePrice = getDataFollowKeyByDot(
      indexSumary,
      Const.indexData.REFERENCE_PRICE,
    );
    const ceilingPrice = getDataFollowKeyByDot(
      indexSumary,
      Const.indexData.CEILING_PRICE,
    );
    const floorPrice = getDataFollowKeyByDot(
      indexSumary,
      Const.indexData.FLOOR_PRICE,
    );
    const dataFormat = this.getDataByTypeSearch(price, referencePrice);

    return (
      <div className="left-info-widget__metas">
        <TextBlinkCustom data={indexSumary} compareKey="tradingDate">
          <PriceInfoCommon
            price={formatTextFloat(dataFormat[0])}
            referencePrice={formatTextFloat(dataFormat[1])}
            change={this.getChangeByTypeSearch()}
            percentChange={formatTextFloat(
              getDataFollowKeyByDot(
                indexSumary,
                Const.indexData.PERCENT_VALUE_CHANGE,
              ) * 100,
            )}
            classNameColor={getColorPrice(
              price,
              referencePrice,
              ceilingPrice,
              floorPrice,
            )}
          />
        </TextBlinkCustom>
      </div>
    );
  }
}

export default connect(mapStateToProps)(PriceInfo);
